/* eslint-disable no-param-reassign */
import { reactive } from 'vue';
import { fetchQuestionTypes } from '../api/eventsSurveys';

export default function useQuestionGroup() {
  const state = reactive({
    questionTypes: [],
  });

  const handleFetchQuestionTypes = async (projectId) => {
    state.questionTypes = await fetchQuestionTypes(projectId);
  };

  return {
    state,
    handleFetchQuestionTypes,
  };
}
